/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { themeToken } from '../../utils/cpds-utils';
import { hexTo8DigitHex } from 'src/components/common/helper';
import { CpdsElevationStyleProps } from '../typings';

const dropShadowMapper = (token, elevation) => {
  if (typeof elevation === 'string') {
    switch (elevation) {
      case 'ONE':
        return `0px 1px 0px 0px ${hexTo8DigitHex(
          token?.elevation_level_one_color,
          token?.elevation_level_one_opacity
        )}`;
      case 'TWO':
        return `0px 2px 4px 0px ${hexTo8DigitHex(
          token?.elevation_level_two_color,
          token?.elevation_level_two_opacity
        )}`;
      case 'FOUR':
        return `0px 4px 7px 0px ${hexTo8DigitHex(
          token?.elevation_level_four_color,
          token?.elevation_level_four_opacity
        )}`;
      case 'SIX':
        return `0px 6px 10px 0px ${hexTo8DigitHex(
          token?.elevation_level_six_color,
          token?.elevation_level_six_opacity
        )}`;
      case 'EIGHT':
        return `0px 8px 16px 0px ${hexTo8DigitHex(
          token?.elevation_level_eight_color,
          token?.elevation_level_eight_opacity
        )}`;
      case 'SIXTEEN':
        return `0px 16px 24px 0px ${hexTo8DigitHex(
          token?.elevation_level_sixteen_color,
          token?.elevation_level_sixteen_opacity
        )}`;
      case 'TWENTY_FOUR':
        return `0px 24px 36px 0px ${hexTo8DigitHex(
          token?.elevation_level_twenty_four_color,
          token?.elevation_level_twenty_four_opacity
        )}`;
    }
  } else {
    return `${elevation.x} ${elevation.y} ${elevation.blur} ${elevation.spread} ${hexTo8DigitHex(
      elevation.color,
      elevation.opacity
    )}`;
  }
};

const ElevationWrapper = styled.div<CpdsElevationStyleProps>`
  ${({
    theme: {
      styles: { cpds },
    },
    elevation = 'ONE',
    borderRadius = '0px',
    ...rest
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, rest?.themeColorMode);

    return css`
      box-shadow: ${dropShadowMapper(token, elevation)};
      border-radius: ${borderRadius};
      ${(props) => props?.styleOverrides}
      width: fit-content;
    `;
  }}
`;

export { ElevationWrapper };
